import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgMoonIconSecondary from './svgs/MoonIconSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var moonIcon = (props => useIcon(null, SvgMoonIconSecondary, props));

export { moonIcon as default };
